<template>
    <div class="w-full h-full">
        <div class="flex items-center justify-end ">

            <button type="button" @click="show_modal = true"
                class="rounded-md border-gray-400 hover:border-gray-600 border px-3 py-2 text-sm font-semibold text-gray-500 shadow-sm focus-visible:outline-none text-left flex items-center gap-x-3">
                <ArrowUpTrayIcon class="size-4 shrink-0" aria-hidden="true" />
                Upload a video…
            </button>

        </div>

        <UploadModal :open="show_modal" max-width="lg" @close="closeModal" :closeable="closeable">

            <DropZone :fileSizeMaxInMb="200" @file-added="fileAdded" @file-removed="fileRemoved"
                @upload-success="uploadSuccess" @upload-error="uploadError" :key="'dropzone_key' + dropzone_key"
                class="w-full" :way="way">

            </DropZone>

        </UploadModal>

    </div>
</template>

<script>
import { ArrowUpTrayIcon } from "@heroicons/vue/16/solid"
import DropZone from '@/Components/Video/DropZone.vue'
import UploadModal from '@/Components/Modals/UploadModal.vue'

export default {
    name: 'Upload',
    props: ['way'],
    components: {
        ArrowUpTrayIcon, DropZone, UploadModal
    },
    data() {
        return {
            dropzone_key: 1,
            show_modal: false,
            closeable: true,
        }
    },
    methods: {
        closeModal() {
            this.show_modal = false
        },
        fileAdded(file) {
            this.closeable = false
        },
        uploadSuccess() {
            this.closeable = true
            this.$emit('uploadSuccess')
            this.show_modal = false
        },
        uploadError() {
            this.closeable = true
            this.$emit('uploadSuccess')
        },
        fileRemoved(file) {
            console.log(file)
        }
    }
}
</script>
